import React, { useContext, useState } from "react";
import {  MenuOutlined, PlusOutlined } from "@ant-design/icons"
import styles from "./index.module.less";
import classNames from "classnames"
import { Divider, Dropdown, Input, Modal, Popover, Space, message } from "antd"
import { SheetContent } from "../../services/modal"
import { FlowsheetContext } from "../../FlowsheetProvider"
import { svgStrToDataUrl } from "@/common/svg"
import { useDispatch } from "react-redux"
import { addSheet, deleteSheet, updateCurrentSheet } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"
import { RootState } from "@/store"
import { getEmptySheetContent } from "../../services/storage"
import { useCurrentSheet } from "../../hooks/useCurrentSheet"
import { OPermission } from "@/components/OPermission/OPermission"
import { ROLE_DRAFTER } from "@/components/OPermission/PlanPermission"

interface FlowFileFooterProps {
  sheets: SheetContent[]
  onAddSheet: (newSheet: SheetContent) => void
}

export function FlowFileFooter(props: FlowFileFooterProps) {
  const {sheets, onAddSheet} = props
  const selectedSheet = useCurrentSheet()
  const sheetsCount = useSelector((state: RootState) => state.flowsheet.content.sheets.length)
  const dispatch = useDispatch();

  const toAddSheet = () => {
    const newSheet = getEmptySheetContent(`Sheet ${sheetsCount + 1}`)
    dispatch(addSheet(newSheet))
    onAddSheet(newSheet)
  }

  const content = <div className={styles.sheetsContainer}>
    <Space>
      {sheets.map(item => {
        return <SheetImg sheet={item} key={`${item.id}_img`} />
      })}
    </Space>
  </div>

  const sheetsTabs = sheets.map(item => {
    return <>
      <Sheet
        key={`${item.id}_sheettab`}
        content={item}
        isActive={selectedSheet?.id === item.id} />
        <Divider type="vertical" key={`${item.id}_divider`} />
    </>
  })

  return <div className={classNames('flex-start', styles.container)}>
    <Popover content={content} title="Sheets" placement="topLeft">
      <div style={{padding: '0 10px'}}>
        <MenuOutlined />
      </div>
    </Popover>
    <Divider type="vertical" />
    {sheetsTabs}
    <OPermission permissions={ROLE_DRAFTER}>
      <div className={styles.addSheet} onClick={toAddSheet}><PlusOutlined style={{fontSize: 18}}/></div>
    </OPermission>
  </div>
}

interface SheetProps {
  isActive?: boolean
  content: SheetContent
}
function Sheet(props: SheetProps) {
  const {isActive = false, content} = props
  const selectedSheet = useCurrentSheet()
  const { setSelectedSheet } = useContext(FlowsheetContext)
  const [showChangeName, setShowChangeName] = useState(false)
  const [name, setName] = useState(content.name)
  const dispatch = useDispatch()
  const sheetsCount = useSelector((state: RootState) => state.flowsheet.content.sheets.length)

  const items = [
    {
      key: 'rename',
      label: 'Rename',
      onClick: () => {
        setShowChangeName(true)
      }
    },
    {
      key: 'delete',
      danger: true,
      label: 'Delete',
      onClick: () => {
        if (sheetsCount > 1) {
          dispatch(deleteSheet(selectedSheet!.id))
        } else {
          message.warning(`Can not to delete the last sheet.`, 3)
        }
      }
    }
  ]

  const updateSheetName = () => {
    setShowChangeName(false)
    dispatch(updateCurrentSheet({name}))
  }

  return <div className={classNames(styles.sheet, isActive && styles.activeSheet)} onClick={async () => {
    if (selectedSheet?.id === content.id) return
    setSelectedSheet(content.id)
  }}>
    <span>{content.name}</span>
    <OPermission permissions={ROLE_DRAFTER}>
      {isActive && <Dropdown menu={{ items }}>
        <div className={styles.moreAction}>...</div>
      </Dropdown>}
    </OPermission>
    
    <Modal
      title="Change Sheet Name"
      open={showChangeName}
      onOk={updateSheetName}
      onCancel={() => {
        setName(content.name)
        setShowChangeName(false)
      }}
    >
      <div>Name:</div>
      <div className="mt-1">
        <Input value={name} onChange={(e) => setName(e.target.value)} />
      </div>
    </Modal>
  </div>
}

interface SheetImgProps {
  sheet: SheetContent
}

function SheetImg(props:SheetImgProps) {
  const {sheet} = props
  return <div className={styles.sheetImgBox}>
    <div className={styles.sheetImg}>
      {/* {sheet.image && <img src={svgStrToDataUrl(sheet.image)} style={{ width: '100%', height: '100%' }} key={`${sheet.id}_sheetimage`} />} */}
      {sheet.image && <div dangerouslySetInnerHTML={{__html: sheet.image}} key={`${sheet.id}_sheetimage`} />}
    </div>
    <div>{sheet.name}</div>
  </div>
}